import { Modal } from "@maysoft/common-component-react"
import { useState, useEffect } from "react"
import { ISystemSetting } from "services/message/systemSetting.service"
import NotificationConfigForm from "../container/postNotification"
import Strings from "constants/strings"
import BasicInfoSection from "../container/baseInfo"

type Props = {
    serviceName: string
    tenantName: string
    visibled: boolean
    onClose: () => void
    data: ISystemSetting
    onSubmit: (value: string) => void
}

const NotificationPopup = ({
    serviceName,
    tenantName,
    visibled,
    onClose,
    data,
    onSubmit
}: Props) => {
    const [value, setValue] = useState("")

    useEffect(() => {
        setValue(data?.settingValue || "")
    }, [data])

    return (
        <Modal
            visible={visibled}
            maxWidth="sm"
            fullWidth
            title="Post Notification"
            buttonAction={Strings.Common.SAVE}
            hasActionButton
            onClose={onClose}
            onAction={() => onSubmit(value)}
        >
             <BasicInfoSection
                title={Strings.SETTING.BASIC}
                items={[
                    {
                        label: Strings.SETTING.SERVICE,
                        value: serviceName
                    },
                    {
                        label: Strings.SETTING.TENANT,
                        value: tenantName
                    }
                ]}
            />
            <NotificationConfigForm
                value={value}
                onChange={setValue}
            />
        </Modal>
    )
}

export default NotificationPopup